import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';

interface Props {
  className?: string;
  container?: boolean;
  item?: boolean;
  spacing?: 0 | 3 | 4 | 6 | 8 | 1 | 10 | 2 | 7 | 5 | 9 | undefined;
  xs?:
    | boolean
    | 'auto'
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | undefined;
  tablet?:
    | boolean
    | 'auto'
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | undefined;
  desktop?:
    | boolean
    | 'auto'
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | undefined;
  children?: ReactNode;
}

export default function Component(props: Props) {
  if (props.container) {
    return (
      <Grid
        spacing={props.spacing || 0}
        className={props.className}
        container={props.container}
        item={props.item}
      >
        {props.children}
      </Grid>
    );
  } else {
    return (
      <Grid
        xs={props.xs}
        md={props.tablet}
        className={props.className}
        item={props.item}
      >
        {props.children}
      </Grid>
    );
  }
}
